



import {Component, Vue} from 'vue-property-decorator';
import AuthCard from "@/components/Organisms/AuthCard/AuthCard.vue";
import CardHeader from "@/components/Atoms/CardHeader/CardHeader.vue";
import RegisterForm from "@/components/Molecules/RegisterForm/RegisterForm.vue";
import ButtonSuccessful from "@/components/Atoms/ButtonSuccessful/ButtonSuccessful.vue";

import {ServiceFactory} from "@/services";
import {LoginFormDto, LoginModel, RegisterFormType} from "@/share";
import {RegisterFormDto} from "@/share/dto/register-form.dto";
import {CHECKBOX_STATUS, COOKIES} from "@/constants";

const AuthService = ServiceFactory.get('auth');

@Component({
  components: {
    AuthCard,
    CardHeader,
    RegisterForm,
    ButtonSuccessful
  }
})
export default class Register extends Vue {
  private isLoading = false
  private error = ''
  private errorMessages = []

  private created() {
    // TODO
  }

  private async register(formData: RegisterFormType) {
    const {babyName, babyBirthday, email, password} = formData;
    const data: RegisterFormDto = new RegisterFormDto({
      babyName: babyName || '',
      babyBirthday: babyBirthday + " 00:00:00" || '',
      email: email || '',
      password: password || '',
    })
    this.error = ''
    this.isLoading = true
    let response = await AuthService.register(data).catch(() => ([]));
    this.isLoading = false

    if (response.hasError) {
      this.error = response.message
      return this.errorMessages = response.errors
    }

    await this.login(data)
    return this.$router.push({name: 'routes.tutorial.start', params: {id: response.babies[0].id}})
  }

  private async login(data: any): Promise<void> {
    const dataLogin: LoginFormDto = new LoginFormDto({
      email: data.email,
      password: data.password,
      rememberMe: CHECKBOX_STATUS.UN_ACCEPTED
    })

    let response = await AuthService.login(dataLogin).catch(() => new LoginModel({}));
    this.isLoading = false
    if (response.hasError) return

    const {accessToken, expiresIn} = response

    if (accessToken) this.$cookies.set(COOKIES.accessToken, accessToken, expiresIn * 60)
  }

  private onBackToPreviousPage(): void {
    console.log('onBackToPreviousPage')
    this.$router.go(-1)
  }
}
